import React from "react";
import { connect } from "react-redux";
import { AccountType } from "component-library";

import { IRoute } from "config/routes";

import { IApplicationState } from "store";

import applicationMap from "services/applicationMap";

import Routes from "app-shell/Routes/Routes";

export interface IJobPageStoreProps {
  userType: AccountType;
}

export interface IJobPageProps extends IJobPageStoreProps {
  routes: IRoute[];
}

export class JobPage extends React.PureComponent<IJobPageProps> {
  private userTypeToExcludedRoutesMap = {
    [AccountType.Agent]: [applicationMap.routes.jobRole()],
    [AccountType.Performer]: [applicationMap.routes.jobBreakdown()],
  };

  public render() {
    const { userType, routes } = this.props;

    return (
      <Routes
        items={routes.filter(
          (route) =>
            !this.userTypeToExcludedRoutesMap[userType].includes(route.path)
        )}
      />
    );
  }
}

const mapStateToProps = (
  state: IApplicationState,
  ownProps: IJobPageProps
): IJobPageStoreProps => {
  return {
    userType: state.user.data!.type,
  };
};

export default connect(mapStateToProps)(JobPage);
